import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInService } from 'views/services/auth';
import { getAccessToken } from 'utils/auth';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const redirectToLogin = useCallback(() => {
    navigate('/auth/sign-in');
  }, [navigate]);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const hasAccessToken = localStorage.getItem('accessToken');

        if (!hasAccessToken) {
          setIsAuthenticated(false);
          setIsLoading(false);
          redirectToLogin();
          return;
        }

        try {
          getAccessToken();
        } catch (_) {
          localStorage.removeItem('accessToken');
          setIsAuthenticated(false);
          setIsLoading(false);
          redirectToLogin();
          return;
        }

        await signInService.sendRefreshRequest();
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem('accessToken');
        setIsAuthenticated(false);
        redirectToLogin();
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [redirectToLogin]);

  const logout = async () => {
    try {
      await signInService.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('accessToken');
      setIsAuthenticated(false);
      navigate('/auth/sign-in');
    }
  };

  return {
    isAuthenticated,
    isLoading,
    logout,
    redirectToLogin,
  };
};
